export default [
  {
    path: '/deposits/:key?',
    name: 'depositsPage',
    component: () => import(/*webpackChunkName:'deposits'*/ '@/views/deposits/index.vue'),
    meta: {},
  },
];
